<template>
    <div class="vue-rental-option-modal-wrapper">
        <div class="modal-header d-flex justify-content-between align-items-start">
            <h3 class="m-0 mb-4">Kies een nieuwe favoriete vestiging</h3>

            <button class="close-button mt-1" @click="handleClose">
                {{ translations.closeText }}
            </button>
        </div>

        <div class="modal-body">
            <div class="">
                <aut-location-dropdown
                    :hide-label="true"
                    @active-location="handleActiveLocation"
                ></aut-location-dropdown>

                <div class="modal-footer d-flex justify-content-end mt-4">
                    <button class="btn btn-primary" @click="saveLocation" :disabled="saving || !selectedLocation">
                        {{ saving ? 'Bezig met opslaan...' : 'Opslaan' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
import Dropdown from "../Location/Dropdown";

export default {
    name: "LocationModal",

    mixins: [translations],

    components: {
        'aut-location-dropdown': Dropdown,
    },

    props: {
        onLocationUpdated: {
            type: Function,
            default: () => {}
        }
    },

    data() {
        return {
            selectedLocation: null,
            saving: false,
        };
    },

    methods: {
        handleClose() {
            this.$modal.close();
        },

        handleActiveLocation(location) {
            this.selectedLocation = location;
        },

        saveLocation() {
            if (!this.selectedLocation) return;

            this.saving = true;
            axios.post('/api/customer/my-location/save', {
                location_id: this.selectedLocation.id
            })
            .then(() => {
                this.$store.dispatch('setActiveLocation', this.selectedLocation);
                console.log('Location saved successfully, calling callback');
                if (typeof this.onLocationUpdated === 'function') {
                    this.onLocationUpdated();
                } else {
                    console.error('onLocationUpdated is not a function:', this.onLocationUpdated);
                }
                this.handleClose();
            })
            .catch(error => {
                console.error('Error saving location:', error);
            })
            .finally(() => {
                this.saving = false;
            });
        }
    }
}
</script>

<style scoped>
/* Ensure the dropdown list is above everything else in the modal */
.dropdown-list {
    z-index: 10001 !important;
}
.v-modal__content .modal-body .modal-description * {
    margin-bottom: 0px;
}
.vue-geo-locator {
    right: 1rem;
}
.v-modal__content .modal-footer {
    padding: 0 0 2rem 0;
}
</style>
